<template>
<div>
  <div class = "container" ref = "slider">
    <p class = "title is-1 title-font section"> {{this.type}} </p>
    <div id = "sliders" > 
      <div class = "columns">
        <div id = "slidercontainer" class = "column is-two-thirds-desktop is-four-fifths-tablet container ontop">
          <div class = "box">

            <div class = "slider" v-for = "(image, index) in images" :key = "image.id">
              <div v-if = "slideShowing[index]" :class = "{'fadein': slideAnimState[index], 'fadeout': !slideAnimState[index]}">
                <figure class="image is-4by3">
                  <img :src="image.displayImage">
                </figure>
              </div>
            </div>

            <div id = "dots" class = "dots">
              <div class = "dots-inline">
                <span class="dot" @click="forceIndex(index)" :class = "{'dot-active': slideShowing[index]}" v-for = "(image, index) in images" :key = "image.id"></span>
              </div>  
            </div>
          </div>
          <p id = "description" class = "has-text-justified is-size-5 description">
            {{slideData[this.type]}}
          </p>
        </div>

      </div>
    </div>

  </div>
</div>
</template>

<script>
import {requester} from '../App.vue';


export default {
  name: 'GalleryDetail',
  data: function(){
    return {
      currentSlideIndex: 0,
      slideAnimState: [], //false if playing hide, true if playing show
      slideShowing: [], //false if hidden, true if showing
      carouselTimeout: null,
      updateDisplayTimeout: null,
      type: "",
      slideData: {
        "Toldo Brazo Stor": "El Toldo Brazo Stor está indicado, principalmente, para utilizarlo en Balcones o Terrazas, con techos y barandas, bien de hierro o de material de construcción. Este tipo de toldo tiene dos posiciones: una totalmente vertical y otra separado de la barandilla por medio de unos brazos plegables de 50 centímetros que están en el tubo de carga. Tiene accionamiento manual.",
        "Toldo Brazo Recto": "El Toldo de Brazo Recto está indicado, principalmente, para utilizarlo en Balcones, Ventanas y Negocios. Este tipo de toldo, con brazos abatibles y con la posibilidad de variar inclinación a gusto del cliente, cuenta con un muelle interior para dar tensión a la lona. La salida de los brazos va desde 0'80 mts hasta 160 centímetros. Accionamiento manual o motorizado con mando a distancia.",
        "Toldo Brazo Articulado": "El Toldo de Brazo Articulado está indicado, principalmente, para Casas particulares exteriores, Grandes fachadas, Comercios y Restaurantes. Este tipo de toldo, con brazos plegables que salen desde los soportes del toldo, es ajustable en altura y no impide el paso. La salida de los brazos va desde 1´25 mts hasta 3´75 mts. Para grandes líneas (ancho) existe el Toldo Articulado Monoblock, que permite instalar más brazos gracias al tubo cuadrado, donde se coloca el toldo con más puntos de anclaje. Para proteger la lona y los brazos de las inclemencias del tiempo y polución existe el Toldo Brazo Articulado Cofre, para el que cuando el toldo está plegado, queda protegido por un perfil delantero y trasero. Accionamiento manual o motorizado con mando a distancia.",
        "Toldo Capota": "El Toldo Capota está indicado principalmente para utilizarlo en ventanas y negocios. Tiene una estructura de aluminio que puede llevar desde 2 hasta 5 arcos, fijas o abatibles. Accionamiento manual.",
        "Toldo Vertical": "El Toldo Vertical está indicado, principalmente, para utilizarlo en Cerramientos de porches y Toldos Vela con estructura, especialmente en cafeterías y restaurantes. Se pueden confeccionar con PVC transparente para permitir el paso de la luz.",
        "Toldo Vela o Plano": "El Toldo Vela o Plano está indicado, principalmente, para utilizarlo en Cafeterías, Restaurantes, Patios, Terrazas y Ojo de patio. Existen dos tipos de velas: las de Anillas y las de Palillerías. Las de Anillas son funcionales y económicas. Las de palillerias, estéticas y duraderas, se pueden intercalar entre paredes con estructuras de aluminio y pérgolas. También se pueden adaptar para proteger de la lluvia. Accionamiento manual.",
        "Toldo Piscina": "También ofrecemos toldos para piscinas."
      },
      images: []
      
    }
  },
  methods: {
    goTo: function(){
      var element = this.$refs["slider"];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
    carousel: function(){
      this.slideAnimState.splice(this.currentSlideIndex, 1, false); //Vue does not detect if you change an element of an array directly with =

      var previousIndex = this.currentSlideIndex;
      if(this.currentSlideIndex == this.images.length-1){
        this.currentSlideIndex = 0;
      } else {
        this.currentSlideIndex++;
      }
      //Waits until the animation finishes to make the element disappear and pop up the new one
      this.updateDisplayTimeout = setTimeout(this.updateDisplay, 500, previousIndex, this.currentSlideIndex);
      //Repeat
      this.carouselTimeout = setTimeout(this.carousel, 10000);

    },
    updateDisplay: function(hideSlideIndex, showSlideIndex){
      this.slideShowing.splice(hideSlideIndex, 1, false);
      this.slideShowing.splice(showSlideIndex, 1, true);
      this.slideAnimState.splice(showSlideIndex, 1, true);
    },

    forceIndex: function(index){
      if(this.images.length > 1){
        clearTimeout(this.carouselTimeout);
        clearTimeout(this.updateDisplayTimeout);
        if(this.currentSlideIndex != index){
          this.slideAnimState.splice(this.currentSlideIndex, 1, false);
          this.updateDisplayTimeout = setTimeout(this.updateDisplay, 500, this.currentSlideIndex, index);
          this.currentSlideIndex = index;
        }
        //If the indexes match, there's no need to change. But we anyways interpret the manual change as more time
        this.carouselTimeout = setTimeout(this.carousel, 20000);
        }
      
    },
    initialize: function(){
      // Initialize visualization arrays
      this.slideAnimState = [];
      this.slideShowing = [];

      for(let i = 0; i < this.images.length; i++){
        if (i == 0) {
          this.slideAnimState.push(true);
          this.slideShowing.push(true);
        } else {
          this.slideAnimState.push(false);
          this.slideShowing.push(false);
         }
       }

        // Starting up sequence
        if(this.images.length > 1){
          this.carouselTimeout = setTimeout(this.carousel, 10000);
        }
        this.goTo();
      },
      reloadImages:function(){
        requester.get('gallery/' + this.type,
        ).then((response) => {
          this.images = response.data;
          this.initialize();
          
          
        }).catch(() => {
          
        })
      }
  },
  mounted: function(){
    this.type = this.$route.params.id;
    this.reloadImages();
  },
  beforeRouteUpdate: function(to, from, next){
    next();
    this.type = this.$route.params.id;
    clearTimeout(this.carouselTimeout);
    clearTimeout(this.updateDisplayTimeout);
    this.reloadImages();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
}
.description{
  padding: 2rem;
}

.fadein{
  position: relative;
  animation: animatein 0.5s;
} @keyframes animatein{from{right:-500px;opacity:0} to{right:0;opacity:1}}

.fadeout{
  position: relative;
  animation: animateout 0.5s;
} @keyframes animateout{from{right:0px;opacity:1} to{right:-500px;opacity:0}}

.dots {
  position: relative;
  width: 50%;
  margin: auto;
  bottom: 40px;
  margin-bottom: -35px;
}
.dots-inline {
  display: inline-flex;
}

.dot{
  margin-left: 5px;
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin-top: 10px;
  background-color: #bbbbbb;
  border-radius: 50%;
  display: flex;
  transition: background-color 0.6s ease;
}

.dot-active{
  background-color: #6f6f6f;
}
</style>